import { Categoria, Lateralidad, Nivel, Posicion, LetraEquipo, Competicion, CategoriaFutura, Seccion } from './enums';

/**
 * Interfaz para la solicitud de creación de informe
 */
export interface InformeRequest {
  nombreCompleto: string;
  nombreEquipo: string;
  letraEquipo: LetraEquipo;
  lateralidad: Lateralidad;
  nivel: Nivel;
  posicion: Posicion;
  año: number;
  dorsal?: number;
  categoriaFutura?: CategoriaFutura;
  partidoId?: number;
  observaciones?: string;
  // Nuevos campos opcionales para informes sin partido
  competicion?: Competicion;
  categoriaEquipo?: Categoria;
  grupoEquipo?: number;
  seccion?: Seccion;
  
  // Habilidades (1-4)
  potenciaFisica?: number;
  velocidad?: number;
  tomaDecision?: number;
  chute?: number;
  tecnicaIndividual?: number;
}

/**
 * Interfaz para la respuesta de informe
 */
export interface InformeResponse {
  id: number;
  nombreCompleto: string;
  nombreEquipo: string;
  letraEquipo: LetraEquipo;
  categoria: Categoria;
  grupo: number;
  lateralidad: Lateralidad;
  nivel: Nivel;
  posicion: Posicion;
  año: number;
  dorsal?: number;
  categoriaFutura?: CategoriaFutura;
  observaciones?: string;
  autor: string;
  partidoId: number;
  nombrePartido: string;
  competicionPartido: Competicion; // Competición del partido (cuando hay partido)
  competicion: Competicion; // Competición del informe (siempre presente)
  createdAt: string;
  updatedAt: string;
  tieneFoto: boolean;
  foto?: File;
  
  // Habilidades (1-4)
  potenciaFisica?: number;
  velocidad?: number;
  tomaDecision?: number;
  chute?: number;
  tecnicaIndividual?: number;
}

/**
 * Interfaz para el formulario de creación de informe
 */
export interface FormularioInforme {
  nombreCompleto: string;
  nombreEquipo: string;
  letraEquipo: LetraEquipo | '';
  lateralidad: Lateralidad | '';
  nivel: Nivel | '';
  posicion: Posicion | '';
  año: number | '';
  dorsal?: number | '';
  categoriaFutura?: CategoriaFutura | '';
  observaciones: string;
  foto?: File | null;
  // Nuevos campos opcionales para informes sin partido
  competicion?: Competicion | '';
  categoriaEquipo?: Categoria | '';
  grupoEquipo?: number | '';
  seccion?: Seccion;
  
  // Habilidades (1-4)
  potenciaFisica: number;
  velocidad: number;
  tomaDecision: number;
  chute: number;
  tecnicaIndividual: number;
}

/**
 * Datos iniciales para el formulario de informe
 */
export const initialFormularioInforme: FormularioInforme = {
  nombreCompleto: '',
  nombreEquipo: '',
  letraEquipo: '',
  lateralidad: '',
  nivel: '',
  posicion: '',
  año: '',
  dorsal: '',
  categoriaFutura: '',
  observaciones: '',
  foto: null,
  competicion: '',
  categoriaEquipo: '',
  grupoEquipo: '',
  // Habilidades por defecto (valor medio 2)
  potenciaFisica: 2,
  velocidad: 2,
  tomaDecision: 2,
  chute: 2,
  tecnicaIndividual: 2
};